/* eslint-disable unicorn/prefer-module */
/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
/* eslint-disable import-helpers/order-imports */
/* eslint-disable arrow-body-style */
/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { Header } from "../Header";
import KebabMenu from "../KebabMenu";
import { useAuthContext } from "../../context/auth";
import { ROLES } from "../../constants/roles";
import { isEdificiosAdmin, puedeEliminarEdificio, INVERSION_CARGA_IDS } from "../../constants/permisos";
import { EdificioForm } from "../EdificioForm";
import { EdificioComisionModal } from "../EdificioComisionModal";
import { getEdificios, eliminarEdificio, updateEdificio, saveEdificio, getCategorias, useCurrency } from "../../utils";
import { getTipoActivoLabel } from "../../constants/clasificacionContable";
import { crearActivo, getActivos, eliminarActivo, actualizarActivo } from "../../utils/activos";
import { calcularImpuesto } from "../../utils/calcularImpuesto";
import { descripcionReal } from "../../utils/conceptoCapex";
import { getPlanCountsByActivo } from "../../utils/planPagosActivos";
import { getProveedores } from "../../utils/proveedores";
import { getLocale } from "../../utils/getLocale";
import { loadExchangeRates } from "../../utils/exchangeRateService";
import { resumenInversionEdificio } from "../../utils/resumenInversionEdificio";

import PlanPagosActivoModal from "../FlujoCajaV2/PlanPagosActivoModal";
import { EdificiosChartModal } from "./EdificiosChartModal";
import styles from "./EdificiosTable.module.scss";

// Badge de estado de una línea de inversión — 3 valores coherentes con el footer de 3 cifras
// (regla 10.185 / criterio contable de la Fase 0): planificado → ámbar; {activo, en_reparacion} →
// verde "Ejecutado"; ejecutado_sin_factura → celeste "Pagado s/factura" (desembolso hecho, aún no
// capitalizado). Cualquier otro estado NO rompe: se muestra crudo en gris neutro.
const getBadgeEstado = (estado) => {
  if (estado === "planificado") return { label: "Planificado", bg: "#fff3cd", color: "#856404" };
  if (estado === "activo" || estado === "en_reparacion")
    return { label: "Ejecutado", bg: "#d4edda", color: "#155724" };
  if (estado === "ejecutado_sin_factura") return { label: "Pagado s/factura", bg: "#d1ecf1", color: "#0c5460" };
  return { label: estado || "—", bg: "#e2e3e5", color: "#383d41" };
};

const EdificiosTable = ({ pais: propPais }) => {
  const [categorias, setCategorias] = useState();
  const [edificios, setEdificios] = useState([]);
  const [editingPersonas, setEditingPersonas] = useState(null); // edificio.id en edición inline de personas
  const [editingPersonasValue, setEditingPersonasValue] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  // Estados para filtros
  const [filtroEstado, setFiltroEstado] = useState("");
  const [filtroContrato, setFiltroContrato] = useState("");
  const [busqueda, setBusqueda] = useState("");

  // Estado para ordenamiento genérico: { key, dir } donde dir = "asc" | "desc" | null
  const [sortConfig, setSortConfig] = useState({ key: null, dir: null });

  // Estados para modal de empresas
  const [showModal, setShowModal] = useState(false);
  const [modalEdificio, setModalEdificio] = useState(null);
  const [modalData, setModalData] = useState({
    empresaslistado: "",
    empresasdestacadas: "",
  });

  // Estados para modal de vetos
  const [showVetosModal, setShowVetosModal] = useState(false);
  const [vetosModalEdificio, setVetosModalEdificio] = useState(null);
  const [vetosModalData, setVetosModalData] = useState([]);

  // Estados para modal de contratos
  const [showContratosModal, setShowContratosModal] = useState(false);
  const [showChartModal, setShowChartModal] = useState(false);
  const [contratosModalEdificio, setContratosModalEdificio] = useState(null);
  const [contratosModalData, setContratosModalData] = useState([]);

  // Estados para modal de inversión
  const [showInversionModal, setShowInversionModal] = useState(false);
  const [inversionEdificio, setInversionEdificio] = useState(null);
  const [inversionActivos, setInversionActivos] = useState([]);
  const [inversionProveedores, setInversionProveedores] = useState([]);
  const [inversionLoading, setInversionLoading] = useState(false);
  // Plan de pagos (CapEx en cuotas): conteo por activo para el indicador "plan de cuotas (N)" +
  // el activo cuyo plan se está viendo/editando ({ activoId, concepto }). Escribe plan_pagos_activos
  // (misma tabla que Caja → única fuente).
  const [inversionPlanCounts, setInversionPlanCounts] = useState({});
  const [planModalActivo, setPlanModalActivo] = useState(null);
  const [nuevaLinea, setNuevaLinea] = useState(null);
  // Línea guardada en modo edición: { id, tipo_activo, proveedor_id, moneda, costo_unitario, fecha, estado }
  const [editandoLinea, setEditandoLinea] = useState(null);
  const [mostrarDetalle, setMostrarDetalle] = useState(false);
  // Menú kebab de acciones por fila: componente compartido <KebabMenu> (patrón 10.136).

  // Estados para el modal de edición de edificio (puerta única, Bloque C Fase 3a)
  const [showEdificioModal, setShowEdificioModal] = useState(false);
  const [edificioModalData, setEdificioModalData] = useState(null);
  const [edificioModalProveedores, setEdificioModalProveedores] = useState([]);
  const [edificioModalSaving, setEdificioModalSaving] = useState(false);

  // Estados para el modal de comisión de edificio (Bloque C Fase 4)
  const [showComisionModal, setShowComisionModal] = useState(false);
  const [comisionModalEdificio, setComisionModalEdificio] = useState(null);
  const [comisionModalSaving, setComisionModalSaving] = useState(false);

  const { pais, rol, id: usuarioId } = useAuthContext(); // Extraer el rol y el id del contexto
  const { formatAmount } = useCurrency();
  const monedaLocal = pais === "Chile" ? "CLP" : "PEN";
  // Resumen financiero del edificio (en moneda local) sobre los activos ya cargados.
  const resumenInversion = useMemo(() => resumenInversionEdificio(inversionActivos, pais), [inversionActivos, pais]);
  // Monto en inputs: separador de miles en vivo (display, SIN símbolo de moneda) y número
  // limpio al guardar. El símbolo de moneda va en la lista, no en el input.
  const formatMontoInput = (raw) => (raw === "" || raw == null ? "" : Number(raw).toLocaleString(getLocale(pais)));
  const parseMontoInput = (str) => str.replace(/\D/g, "");
  // IVA/IGV de una línea de inversión (CapEx-IVA Fase 1). Reusa el util canónico calcularImpuesto
  // (reglas 10.19/10.27); NO toca el neto (costo_unitario). El impuesto local solo aplica si la
  // línea es afecta (exento=false) Y su moneda es la local del país (una línea USD/UF no lleva IVA
  // local → 0). Devuelve { iva, total, aplica } para pintar las columnas Neto·IVA·Total del detalle.
  const ivaLineaInversion = (neto, moneda, exento) => {
    const n = Number(neto || 0);
    const aplica = !exento && moneda === monedaLocal && n > 0;
    const iva = aplica ? calcularImpuesto(n, pais).impuesto : 0;
    return { iva, total: n + iva, aplica };
  };

  // Gate de la puerta única de edición (Bloque C): solo Ignacio [1,4].
  const puedeEditarTodoEdificio = isEdificiosAdmin(usuarioId);
  // Eliminar edificio: puerta más restrictiva que editar (solo Ignacio CHI=1 / PER=4). Ver
  // ELIMINAR_EDIFICIO_IDS en constants/permisos.js — restricción de UI temporal (ver ROADMAP).
  const puedeEliminarEdificioActual = puedeEliminarEdificio(usuarioId);

  // Permisos por rol
  const puedeEditarTodo = rol === ROLES.SUPERADMIN || rol === ROLES.GERENCIA;
  const puedeEditarParcial = rol === ROLES.ADMINISTRATIVO || rol === ROLES.INFRAESTRUCTURA;
  const puedeEditar = puedeEditarTodo || puedeEditarParcial;
  const soloLectura = !puedeEditar;
  // Carga de inversión (CapEx planificado): puedeEditarTodo (superadmin/gerencia) + allowlist
  // dedicada por-id (INVERSION_CARGA_IDS) para casos puntuales sin cambiar el rol del usuario.
  const puedeCargarInversion = puedeEditarTodo || INVERSION_CARGA_IDS.includes(Number(usuarioId));

  const TIPOS_ACTIVO_INVERSION = [
    "pantalla",
    "reproductor",
    "soporte",
    "totem",
    "antena",
    "costo_instalacion",
    "insumos_instalacion",
    "herramientas",
    "otro",
  ];

  // Conteo de cuotas por activo planificado (indicador "plan de cuotas (N)"). Se recarga al abrir el
  // modal y tras guardar un plan.
  const cargarPlanCounts = async (activos) => {
    const planificadoIds = (activos || []).filter((a) => a.estado === "planificado").map((a) => a.id);
    try {
      setInversionPlanCounts(planificadoIds.length > 0 ? await getPlanCountsByActivo(planificadoIds) : {});
    } catch {
      setInversionPlanCounts({});
    }
  };

  const handleOpenInversionModal = async (edificio) => {
    setInversionEdificio(edificio);
    setShowInversionModal(true);
    setMostrarDetalle(true); // la tabla de activos abre EXPANDIDA (el toggle sigue para colapsar a mano)
    setInversionLoading(true);
    try {
      // loadExchangeRates: el resumen convierte activos USD/UF/PEN a moneda local (TC histórico);
      // asegurar tasas antes de mostrar para no calcular con 0.
      const [activos, provs] = await Promise.all([
        getActivos(pais, { destino_tipo: "edificio", destino_id: edificio.id }),
        getProveedores(pais),
        loadExchangeRates(),
      ]);
      setInversionActivos(activos);
      setInversionProveedores(provs);
      await cargarPlanCounts(activos);
    } catch (err) {
      console.error("Error cargando inversiones:", err);
      toast.error("Error cargando inversiones");
    } finally {
      setInversionLoading(false);
    }
  };

  const handleGuardarLinea = async () => {
    if (!nuevaLinea?.tipo_activo || !nuevaLinea?.costo_unitario) {
      toast.error("Tipo y monto son obligatorios");
      return;
    }
    if (!nuevaLinea?.fecha_planificada) {
      toast.error("La fecha es obligatoria");
      return;
    }
    if (!nuevaLinea?.proveedor_id) {
      toast.error("El proveedor es obligatorio");
      return;
    }
    try {
      // El modal Inversión SOLO planifica inversión futura: toda alta nace estado='planificado'
      // con fecha_compra NULL y fecha_planificada = fecha estimada de PAGO (proyecta CapEx). La
      // fecha real de compra se setea al ejecutar vinculando el banco (path "Compra de activo",
      // D.2). Lo ejecutado/histórico se carga por GestionActivos (ABM 4.13), no acá.
      const activo = await crearActivo({
        pais,
        fecha_compra: null,
        tipo_activo: nuevaLinea.tipo_activo,
        // Fase 3a: descripción de texto libre. Si el usuario la deja vacía, persiste '' (NO se
        // vuelve a igualar a tipo_activo — eso generaba basura duplicada). descripcion es NOT NULL,
        // '' es válido.
        descripcion: nuevaLinea.descripcion || "",
        cantidad: 1,
        costo_unitario: Number(nuevaLinea.costo_unitario),
        moneda: nuevaLinea.moneda || "CLP",
        vida_util_meses: 60,
        valor_residual: 0,
        estado: "planificado",
        fecha_planificada: nuevaLinea.fecha_planificada,
        destino_tipo: "edificio",
        destino_id: inversionEdificio.id,
        proyecto_nombre: nuevaLinea.proyecto_nombre || null,
        proveedor_id: nuevaLinea.proveedor_id || null,
        exento_iva: !!nuevaLinea.exento_iva, // marca afecto/exento (el neto NO cambia)
      });
      setInversionActivos((prev) => [activo, ...prev]);
      setNuevaLinea(null);
      toast.success("Línea agregada");
    } catch (err) {
      console.error("Error al guardar activo:", err, JSON.stringify(err));
      toast.error("Error al guardar: " + (err.message || err));
    }
  };

  const handleEliminarLinea = async (id) => {
    if (!window.confirm("¿Borrar esta línea de inversión?")) return;
    try {
      await eliminarActivo(id);
      setInversionActivos((prev) => prev.filter((a) => a.id !== id));
      toast.success("Línea eliminada");
    } catch {
      toast.error("Error al eliminar");
    }
  };

  // Soft-delete de un edificio (edificios.eliminada = true). El confirm incluye nombre + ubicación
  // porque hay edificios con el mismo nombre (ej. "CV GALERÍA") y no queremos borrar el equivocado.
  const handleEliminarEdificio = async (edificio) => {
    const detalle = [edificio.edificio, edificio.ubicacion].filter(Boolean).join(" — ");
    if (!window.confirm(`¿Eliminar el edificio "${detalle}"?\n\nSe ocultará de la lista (soft-delete, reversible).`)) return;
    try {
      await eliminarEdificio(edificio.id);
      setEdificios((prev) => prev.filter((e) => e.id !== edificio.id));
      toast.success("Edificio eliminado");
    } catch {
      toast.error("Error al eliminar el edificio");
    }
  };

  // Abre una línea guardada en modo edición con sus valores actuales.
  const handleEditarLinea = (a) => {
    setNuevaLinea(null);
    setEditandoLinea({
      id: a.id,
      tipo_activo: a.tipo_activo || "",
      proveedor_id: a.proveedor_id || null,
      moneda: a.moneda || "CLP",
      costo_unitario: a.costo_unitario != null ? String(a.costo_unitario) : "",
      fecha: a.fecha_planificada || a.fecha_compra || "",
      estado: a.estado || "activo",
      exento_iva: !!a.exento_iva,
      // Fase 3a: precarga descripción REAL (los legacy con descripcion=tipo_activo entran vacíos,
      // así el usuario no ve "PANTALLA" repetido).
      descripcion: descripcionReal(a),
    });
  };

  // Guarda la edición de una línea (update parcial de los campos editables).
  // fecha de la línea = fecha_compra; en planificado también alimenta la proyección CapEx.
  const handleGuardarEdicion = async () => {
    const e = editandoLinea;
    if (!e?.tipo_activo || !e?.costo_unitario) {
      toast.error("Tipo y monto son obligatorios");
      return;
    }
    if (!e?.fecha) {
      toast.error("La fecha es obligatoria");
      return;
    }
    try {
      const cambios = {
        tipo_activo: e.tipo_activo,
        proveedor_id: e.proveedor_id || null,
        moneda: e.moneda || "CLP",
        costo_unitario: Number(e.costo_unitario),
        // Fase 3a: descripción libre ('' si vacía, sin regenerar tipo_activo).
        descripcion: e.descripcion || "",
        // Planificado: la fecha es estimada de pago (fecha_planificada), fecha_compra NULL.
        // Ejecutado: la fecha es la de compra real (manda para ER).
        fecha_compra: e.estado === "planificado" ? null : e.fecha || null,
        fecha_planificada: e.estado === "planificado" ? e.fecha || null : null,
        estado: e.estado || "activo",
        exento_iva: !!e.exento_iva, // marca afecto/exento (el neto NO cambia)
      };
      await actualizarActivo(e.id, cambios);
      setInversionActivos((prev) =>
        prev.map((a) =>
          a.id === e.id
            ? { ...a, ...cambios, proveedor: inversionProveedores.find((p) => p.id === cambios.proveedor_id) || null }
            : a
        )
      );
      setEditandoLinea(null);
      toast.success("Línea actualizada");
    } catch (err) {
      console.error("Error al actualizar línea:", err);
      toast.error("Error al actualizar: " + (err.message || err));
    }
  };

  // Estados únicos para filtro
  const estadosUnicos = useMemo(() => {
    return [...new Set(edificios.map((e) => e.estado))].filter(Boolean);
  }, [edificios]);

  // Función helper para verificar si tiene contrato vigente de un tipo
  const tieneContratoVigente = useCallback((contratos, tipo) => {
    if (!contratos || !Array.isArray(contratos)) return false;
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    return contratos.some((c) => {
      if (c.tipo !== tipo) return false;
      const fechaFin = new Date(c.fechafin + "T23:59:59");
      const fechaInicio = new Date(c.fechainicio + "T00:00:00");
      return hoy >= fechaInicio && hoy <= fechaFin;
    });
  }, []);

  // Función para ciclar ordenamiento: null → asc → desc → null
  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key !== key) return { key, dir: "asc" };
      if (prev.dir === "asc") return { key, dir: "desc" };
      return { key: null, dir: null };
    });
  };

  // Indicador de sort para el header
  const sortIndicator = (key) => {
    if (sortConfig.key !== key) return "";
    return sortConfig.dir === "asc" ? " \u25B2" : " \u25BC";
  };

  // Edificios filtrados
  const edificiosFiltrados = useMemo(() => {
    const filtrados = edificios.filter((edificio) => {
      if (filtroEstado && edificio.estado !== filtroEstado) return false;
      if (busqueda && !edificio.edificio?.toLowerCase().includes(busqueda.toLowerCase())) return false;
      if (filtroContrato && !tieneContratoVigente(edificio.contratos, filtroContrato)) return false;
      return true;
    });

    if (sortConfig.key && sortConfig.dir) {
      filtrados.sort((a, b) => {
        let valA, valB;
        switch (sortConfig.key) {
          case "edificio":
            valA = (a.edificio || "").toLowerCase();
            valB = (b.edificio || "").toLowerCase();
            break;
          case "estado":
            valA = a.estado || "";
            valB = b.estado || "";
            break;
          case "inicio_servicio":
            valA = a.inicio_servicio || "";
            valB = b.inicio_servicio || "";
            break;
          case "personas":
            valA = a.personas || 0;
            valB = b.personas || 0;
            return sortConfig.dir === "asc" ? valA - valB : valB - valA;
          case "estacionamientos":
            valA = a.estacionamientos || 0;
            valB = b.estacionamientos || 0;
            return sortConfig.dir === "asc" ? valA - valB : valB - valA;
          default:
            return 0;
        }
        return sortConfig.dir === "asc" ? valA.localeCompare(valB) : valB.localeCompare(valA);
      });
    }

    return filtrados;
  }, [edificios, filtroEstado, filtroContrato, busqueda, tieneContratoVigente, sortConfig]);

  // Estadísticas para el header - conteo por estado
  const estadisticas = useMemo(() => {
    // Orden fijo de estados
    const ordenEstados = ["OPERATIVO", "INSTALACIÓN", "PROYECTO", "STANDBY", "SIN ESTADO"];

    // Contar edificios por estado (usando edificios sin filtrar para el header)
    const conteoPorEstado = {};
    ordenEstados.forEach((estado) => {
      conteoPorEstado[estado] = 0;
    });

    edificios.forEach((e) => {
      const estado = e.estado && e.estado.trim() !== "" ? e.estado : "SIN ESTADO";
      if (conteoPorEstado[estado] !== undefined) {
        conteoPorEstado[estado]++;
      } else {
        // Estado no previsto, agregar a "SIN ESTADO"
        conteoPorEstado["SIN ESTADO"]++;
      }
    });

    return {
      estados: ordenEstados.map((estado) => ({
        nombre: estado,
        cantidad: conteoPorEstado[estado],
      })),
      totalEdificios: edificios.length,
    };
  }, [edificios]);

  // Formatear fecha como "MAY 25" (mes abreviado + año corto)
  const formatMesAnio = (fechaStr) => {
    if (!fechaStr) return "-";
    const date = new Date(fechaStr + "T12:00:00");
    const mes = date.toLocaleDateString("es", { month: "short" }).toUpperCase().replace(".", "");
    const anio = date.toLocaleDateString("es", { year: "2-digit" });
    return `${mes} ${anio}`;
  };

  // Formatear fecha corta
  const formatFecha = (fechaStr) => {
    if (!fechaStr) return "-";
    return new Date(fechaStr + "T12:00:00").toLocaleDateString("es", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });
  };

  // Formatear porcentaje con 1 decimal según país
  const formatPorcentaje = useCallback(
    (valor) => {
      if (!valor && valor !== 0) return "-";
      const numero = typeof valor === "string" ? parseFloat(valor) : valor;
      return numero.toLocaleString(getLocale(pais), {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
    },
    [pais]
  );

  // Calcular estado de contrato: VIGENTE, POR VENCER (menos de 60 días), VENCIDO
  const getContratoStatus = (contratos, tipo) => {
    if (!contratos || !Array.isArray(contratos)) return null;
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    // Filtrar contratos del tipo especificado y ordenar por fechafin descendente
    const contratosDelTipo = contratos
      .filter((c) => c.tipo === tipo)
      .sort((a, b) => new Date(b.fechafin) - new Date(a.fechafin));

    if (contratosDelTipo.length === 0) return null;

    // Tomar el contrato más reciente
    const contrato = contratosDelTipo[0];
    const fechaFin = new Date(contrato.fechafin + "T23:59:59");
    const fechaInicio = new Date(contrato.fechainicio + "T00:00:00");

    // Si aún no empezó
    if (hoy < fechaInicio) return { status: "PENDIENTE", color: "#6c757d" };

    // Si ya terminó
    if (hoy > fechaFin) return { status: "VENCIDO", color: "#dc3545" };

    // Calcular días restantes
    const diasRestantes = Math.ceil((fechaFin - hoy) / (1000 * 60 * 60 * 24));

    if (diasRestantes <= 60) {
      return { status: "POR VENCER", color: "#b8860b" }; // Amarillo oscuro (DarkGoldenrod)
    }

    return { status: "VIGENTE", color: "#28a745" };
  };

  // Función reutilizable para obtener edificios y ordenarlos
  const fetchEdificios = async () => {
    try {
      const data = await getEdificios({ pais: propPais || pais });

      // Ordenar los edificios primero por estado y luego por cantidad de personas
      const sortedData = data.sort((a, b) => {
        const estadosOrder = { OPERATIVO: 1, INSTALACIÓN: 2, PROYECTO: 3, STANDBY: 4 };
        // Obtener el orden del estado, si no existe o está vacío, asignar 5 (último)
        const ordenA = a.estado && a.estado.trim() !== "" ? estadosOrder[a.estado] || 5 : 5;
        const ordenB = b.estado && b.estado.trim() !== "" ? estadosOrder[b.estado] || 5 : 5;

        if (ordenA !== ordenB) {
          return ordenA - ordenB;
        }
        return (b.personas || 0) - (a.personas || 0);
      });

      setEdificios(sortedData);
    } catch (err) {
      setError(err.message);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Inicializa categorías y edificios
  useEffect(() => {
    const initialize = async () => {
      const newCategorias = await getCategorias();
      setCategorias(newCategorias);
    };

    initialize();
  }, [pais]);

  // Usa fetchEdificios para cargar datos iniciales
  useEffect(() => {
    fetchEdificios();
  }, [propPais, pais]);

  // Edición inline de PERSONAS (click-to-edit)
  const handlePersonasClick = (edificio) => {
    if (!puedeEditar) return;
    setEditingPersonas(edificio.id);
    setEditingPersonasValue(edificio.personas?.toString() || "");
  };

  const handlePersonasSave = async (edificioId) => {
    const trimmed = editingPersonasValue.trim();
    const newValue = trimmed === "" ? null : parseInt(trimmed.replace(/\D/g, ""), 10);
    if (newValue !== null && Number.isNaN(newValue)) {
      setEditingPersonas(null);
      return;
    }
    const edificio = edificios.find((e) => e.id === edificioId);
    if (!edificio) {
      setEditingPersonas(null);
      return;
    }
    try {
      // Pasar campos existentes para no pisarlos: updateEdificio hace PATCH y
      // empresaslistado/empresasdestacadas caen a null si no se envían.
      await updateEdificio({
        id: edificioId,
        personas: newValue,
        estacionamientos: edificio.estacionamientos,
        vetos: edificio.vetos || "",
        empresaslistado: edificio.empresaslistado || "",
        empresasdestacadas: edificio.empresasdestacadas || "",
      });
      setEdificios((prev) => prev.map((e) => (e.id === edificioId ? { ...e, personas: newValue } : e)));
    } catch (err) {
      console.error("Error actualizando personas:", err);
      toast.error("Error actualizando personas");
    }
    setEditingPersonas(null);
  };

  const handlePersonasCancel = () => {
    setEditingPersonas(null);
  };

  // Obtener lista de empresas como array (debe estar antes de early returns)
  const empresasArray = useMemo(() => {
    if (!modalData.empresaslistado) return [];
    return modalData.empresaslistado
      .split(",")
      .map((e) => e.trim())
      .filter((e) => e.length > 0);
  }, [modalData.empresaslistado]);

  // Obtener empresas destacadas como array
  const destacadasArray = useMemo(() => {
    if (!modalData.empresasdestacadas) return [];
    return modalData.empresasdestacadas
      .split(",")
      .map((e) => e.trim())
      .filter((e) => e.length > 0);
  }, [modalData.empresasdestacadas]);

  // Categorías ordenadas alfabéticamente (debe estar antes de early returns)
  const categoriasOrdenadas = useMemo(() => {
    if (!categorias) return [];
    return [...categorias].sort((a, b) => a.nombre.localeCompare(b.nombre));
  }, [categorias]);

  // Funciones para modal de empresas
  const handleOpenEmpresasModal = (edificio) => {
    setModalEdificio(edificio);
    setModalData({
      empresaslistado: edificio.empresaslistado || "",
      empresasdestacadas: edificio.empresasdestacadas || "",
    });
    setShowModal(true);
  };

  // Toggle empresa destacada
  const handleToggleDestacada = (empresa) => {
    const isDestacada = destacadasArray.includes(empresa);
    if (isDestacada) {
      // Remover de destacadas
      const newDestacadas = destacadasArray.filter((e) => e !== empresa);
      setModalData((prev) => ({
        ...prev,
        empresasdestacadas: newDestacadas.join(", "),
      }));
    } else {
      // Agregar a destacadas (máximo 5)
      if (destacadasArray.length >= 5) {
        toast.error("Máximo 5 empresas destacadas");
        return;
      }
      setModalData((prev) => ({
        ...prev,
        empresasdestacadas: [...destacadasArray, empresa].join(", "),
      }));
    }
  };

  const handleSaveEmpresasModal = async () => {
    try {
      setLoading(true);
      const updatedData = {
        id: modalEdificio.id,
        personas: modalEdificio.personas,
        estacionamientos: modalEdificio.estacionamientos,
        vetos: modalEdificio.vetos || "",
        empresaslistado: modalData.empresaslistado,
        empresasdestacadas: modalData.empresasdestacadas,
      };
      await updateEdificio(updatedData);
      setShowModal(false);
      toast.success("Empresas actualizadas exitosamente");
      await fetchEdificios();
    } catch (error) {
      console.error("Error al actualizar empresas:", error);
      toast.error("Error al actualizar empresas");
    } finally {
      setLoading(false);
    }
  };

  // Funciones para modal de vetos
  const handleOpenVetosModal = (edificio) => {
    const vetosArray = edificio.vetos ? edificio.vetos.split(",").map((v) => v.trim()) : [];
    setVetosModalEdificio(edificio);
    setVetosModalData(vetosArray);
    setShowVetosModal(true);
  };

  const handleVetosModalChange = (categoriaId) => {
    setVetosModalData((prev) => {
      if (prev.includes(categoriaId)) {
        return prev.filter((id) => id !== categoriaId);
      }
      return [...prev, categoriaId];
    });
  };

  const handleSaveVetosModal = async () => {
    try {
      setLoading(true);
      const formattedVetos = vetosModalData.join(", ");
      const updatedData = {
        id: vetosModalEdificio.id,
        personas: vetosModalEdificio.personas,
        estacionamientos: vetosModalEdificio.estacionamientos,
        vetos: formattedVetos,
        empresaslistado: vetosModalEdificio.empresaslistado || "",
        empresasdestacadas: vetosModalEdificio.empresasdestacadas || "",
      };
      await updateEdificio(updatedData);
      setShowVetosModal(false);
      toast.success("Vetos actualizados exitosamente");
      await fetchEdificios();
    } catch (error) {
      console.error("Error al actualizar vetos:", error);
      toast.error("Error al actualizar vetos");
    } finally {
      setLoading(false);
    }
  };

  // Funciones para modal de contratos
  const handleOpenContratosModal = (edificio) => {
    setContratosModalEdificio(edificio);
    // Parsear contratos existentes o inicializar array vacío
    const contratosExistentes = edificio.contratos || [];
    setContratosModalData(Array.isArray(contratosExistentes) ? contratosExistentes : []);
    setShowContratosModal(true);
  };

  const handleAddContrato = (tipo) => {
    setContratosModalData((prev) => [...prev, { tipo, fechainicio: "", fechafin: "" }]);
  };

  const handleRemoveContrato = (index) => {
    setContratosModalData((prev) => prev.filter((_, i) => i !== index));
  };

  const handleContratoChange = (index, field, value) => {
    setContratosModalData((prev) =>
      prev.map((contrato, i) => (i === index ? { ...contrato, [field]: value } : contrato))
    );
  };

  const handleSaveContratosModal = async () => {
    try {
      setLoading(true);
      // Filtrar contratos incompletos (sin fechas)
      const contratosValidos = contratosModalData.filter((c) => c.fechainicio && c.fechafin);
      const updatedData = {
        id: contratosModalEdificio.id,
        personas: contratosModalEdificio.personas,
        estacionamientos: contratosModalEdificio.estacionamientos,
        vetos: contratosModalEdificio.vetos || "",
        empresaslistado: contratosModalEdificio.empresaslistado || "",
        empresasdestacadas: contratosModalEdificio.empresasdestacadas || "",
        contratos: contratosValidos,
      };
      await updateEdificio(updatedData);
      setShowContratosModal(false);
      toast.success("Contratos actualizados exitosamente");
      await fetchEdificios();
    } catch (error) {
      console.error("Error al actualizar contratos:", error);
      toast.error("Error al actualizar contratos");
    } finally {
      setLoading(false);
    }
  };

  // ── Modal de edición de edificio (puerta única, Bloque C Fase 3a) ──
  const handleOpenEdificioModal = async (edificio) => {
    setEdificioModalData(edificio);
    setShowEdificioModal(true);
    try {
      const provs = await getProveedores(pais);
      setEdificioModalProveedores(provs);
    } catch (err) {
      console.error("Error cargando proveedores:", err);
      setEdificioModalProveedores([]);
    }
  };

  const handleSaveEdificioModal = async (objEntero) => {
    setEdificioModalSaving(true);
    // EdificioForm en modo crear parte de edificio=null → el objeto no trae `id`.
    const esEdicion = !!objEntero.id;
    try {
      if (esEdicion) {
        // objEntero ya trae el edificio completo (regla 10.54): comisión re-pasada intacta.
        await updateEdificio(objEntero);
      } else {
        // Crear: normalizar "" → null (columnas numéricas/date) e inyectar país, igual que
        // CargarEdificio (Fase 3b). Nace SIN comisión: las columnas comision_* nullable no se setean.
        const limpio = Object.fromEntries(Object.entries(objEntero).map(([k, v]) => [k, v === "" ? null : v]));
        await saveEdificio({ ...limpio, pais });
      }
      await fetchEdificios();
      setShowEdificioModal(false);
      setEdificioModalData(null);
      toast.success(esEdicion ? "Edificio actualizado exitosamente" : "Edificio creado exitosamente");
    } catch (error) {
      console.error("Error al guardar edificio:", error);
      toast.error(esEdicion ? "Error al actualizar el edificio" : "Error al crear el edificio");
    } finally {
      setEdificioModalSaving(false);
    }
  };

  // ── Modal de comisión de edificio (Bloque C Fase 4) ──
  const handleOpenComisionModal = (edificio) => {
    setComisionModalEdificio(edificio);
    setShowComisionModal(true);
  };

  const handleSaveComisionModal = async (objEntero) => {
    setComisionModalSaving(true);
    try {
      // objEntero trae el edificio completo con las 13 columnas de comisión actualizadas (regla 10.54).
      await updateEdificio(objEntero);
      await fetchEdificios();
      setShowComisionModal(false);
      setComisionModalEdificio(null);
      toast.success("Comisión actualizada exitosamente");
    } catch (error) {
      console.error("Error al actualizar comisión:", error);
      toast.error("Error al actualizar la comisión");
    } finally {
      setComisionModalSaving(false);
    }
  };

  // Badge de estado del ciclo de vida del edificio (Fase 1)
  const renderEstadoBadge = (estado) => {
    const map = {
      PROSPECTO: styles.estadoProspecto,
      PROYECTO: styles.estadoProyecto,
      PILOTO: styles.estadoPiloto,
      INSTALACIÓN: styles.estadoInstalacion,
      OPERATIVO: styles.estadoOperativo,
      CADUCADO: styles.estadoCaducado,
    };
    const cls = map[estado] || "";
    return <span className={`${styles.estadoBadge} ${cls}`}>{estado || "—"}</span>;
  };

  // Acciones del kebab por edificio — MISMOS gates de rol que los botones originales
  // (el kebab es solo presentación, no relaja permisos, regla 10.136):
  // Empresas/Vetos siempre; Cartelería → puedeEditarTodo; Inversión → puedeCargarInversion
  // (puedeEditarTodo + allowlist INVERSION_CARGA_IDS); Comisiones/Editar → puedeEditarTodoEdificio;
  // Eliminar → puedeEliminarEdificioActual (puerta propia, más restrictiva: solo Ignacio CHI/PER).
  const accionesDeEdificio = (ed) => {
    const acc = [
      { label: "Empresas", onClick: () => handleOpenEmpresasModal(ed) },
      { label: "Vetos", onClick: () => handleOpenVetosModal(ed) },
    ];
    if (puedeEditarTodo) {
      acc.push({ label: "Cartelería", onClick: () => handleOpenContratosModal(ed) });
    }
    if (puedeCargarInversion) {
      acc.push({ label: "Inversión", onClick: () => handleOpenInversionModal(ed) });
    }
    if (puedeEditarTodoEdificio) {
      acc.push(
        { label: "Comisiones", onClick: () => handleOpenComisionModal(ed) },
        { label: "Editar", onClick: () => handleOpenEdificioModal(ed) }
      );
    }
    // "Eliminar" cuelga de su propia puerta (más restrictiva que editar): solo Ignacio.
    if (puedeEliminarEdificioActual) {
      acc.push({ label: "Eliminar", danger: true, onClick: () => handleEliminarEdificio(ed) });
    }
    return acc;
  };

  // Early returns
  if (loading) return <div>Cargando edificios...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className={styles.pageContainer}>
      <Header
        leftContent={
          <div className={styles.statsGrid}>
            {estadisticas.estados.map((item) => (
              <div key={item.nombre} className={styles.statItem}>
                <span className={styles.statLabel}>{item.nombre}:</span>
                <strong className={styles.statValue}>{item.cantidad}</strong>
              </div>
            ))}
          </div>
        }
      >
        <div className={styles.filterRow}>
          <div className={styles.filterItem}>
            <select
              className={styles.filterSelect}
              value={filtroEstado}
              onChange={(e) => setFiltroEstado(e.target.value)}
            >
              <option value="">Todos los estados</option>
              {estadosUnicos.map((estado, i) => (
                <option key={i} value={estado}>
                  {estado}
                </option>
              ))}
            </select>
          </div>
          <div className={styles.filterItem}>
            <select
              className={`${styles.filterSelect} ${filtroContrato ? styles.activeFilter : ""}`}
              value={filtroContrato}
              onChange={(e) => setFiltroContrato(e.target.value)}
            >
              <option value="">Todos los contratos</option>
              <option value="INVENTARIO">INVENTARIO vigente</option>
              <option value="CARTELERÍA">CARTELERÍA vigente</option>
            </select>
          </div>
          <div className={styles.filterItem}>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Buscar edificio..."
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
              style={{ height: "2.5rem", borderRadius: "8px" }}
            />
          </div>
          <button className="chart-btn" onClick={() => setShowChartModal(true)} title="Ver gráfico de crecimiento">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
            </svg>
            Gráfico
          </button>
          {puedeEditarTodoEdificio && (
            <button className="btn btn-sm btn-primary" onClick={() => handleOpenEdificioModal(null)}>
              + Edificio
            </button>
          )}
        </div>
      </Header>

      <div className={styles.contentWrapper}>
        <table className={`table table-bordered table-striped table-hover small text-sm ${styles.edificiosTable}`}>
          <thead>
            <tr className="table-dark text-center">
              <th
                rowSpan={3}
                className={`${styles.colEstado} ${styles.sortableHeader}`}
                onClick={() => handleSort("estado")}
              >
                ESTADO{sortIndicator("estado")}
              </th>
              <th
                rowSpan={3}
                className={`${styles.colNombre} ${styles.sortableHeader}`}
                onClick={() => handleSort("edificio")}
              >
                NOMBRE{sortIndicator("edificio")}
              </th>
              <th rowSpan={3} className={styles.colUbicacion}>
                UBICACIÓN
              </th>
              <th rowSpan={3} className={styles.colPersonas}>
                PERSONAS
              </th>
              <th colSpan={6} className={styles.colPantallasGrupo}>
                PANTALLAS
              </th>
              <th rowSpan={3} className={styles.colContrato}>
                CONTRATO
              </th>
              <th rowSpan={3} className={styles.colAcciones}>
                ACCIONES
              </th>
            </tr>
            <tr className="table-dark text-center">
              <th colSpan={4} className={styles.colSubGrupoInv}>
                INV. PUBLICITARIO
              </th>
              <th colSpan={2} className={styles.colSubGrupoCart}>
                CARTELERÍA
              </th>
            </tr>
            <tr className="table-dark text-center">
              <th className={styles.colAsc}>ASC</th>
              <th className={styles.colCir}>CIR</th>
              <th className={styles.colEsp}>ESP</th>
              <th className={styles.colCow}>COW</th>
              <th className={styles.colDir}>DIR</th>
              <th className={styles.colOtr}>OTR</th>
            </tr>
          </thead>
          <tbody>
            {edificiosFiltrados.map((edificio) => (
              <tr key={edificio.id}>
                <td className={styles.colEstado}>{renderEstadoBadge(edificio.estado)}</td>
                <td className={styles.colNombre} style={{ textAlign: "left" }}>
                  {edificio.edificio ? edificio.edificio.toUpperCase() : "—"}
                </td>
                <td className={styles.colUbicacion}>
                  {edificio.direccion ? `${edificio.direccion}, ${edificio.ubicacion}` : edificio.ubicacion || "—"}
                </td>
                <td className="text-center" style={{ cursor: puedeEditar ? "pointer" : "default" }}>
                  {editingPersonas === edificio.id ? (
                    <input
                      type="text"
                      value={editingPersonasValue}
                      onChange={(e) => setEditingPersonasValue(e.target.value)}
                      onBlur={() => handlePersonasSave(edificio.id)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handlePersonasSave(edificio.id);
                        if (e.key === "Escape") handlePersonasCancel();
                      }}
                      autoFocus
                      style={{
                        width: "100%",
                        textAlign: "center",
                        border: "1px solid #0d6efd",
                        borderRadius: "3px",
                        padding: "2px 4px",
                        fontSize: "inherit",
                        backgroundColor: "#fff",
                      }}
                    />
                  ) : (
                    <span onClick={() => handlePersonasClick(edificio)}>
                      {edificio.personas ? Number(edificio.personas).toLocaleString(getLocale(pais)) : "—"}
                    </span>
                  )}
                </td>
                <td className={styles.colAsc}>{edificio.pantallas || "—"}</td>
                <td className={styles.colCir}>{edificio.totems || "—"}</td>
                <td className={styles.colEsp}>{edificio.espera || "—"}</td>
                <td className={styles.colCow}>{edificio.cowork || "—"}</td>
                <td className={styles.colDir}>—</td>
                <td className={styles.colOtr}>—</td>
                <td className={styles.colContrato}>
                  {(() => {
                    const statusInv = getContratoStatus(edificio.contratos, "INVENTARIO");
                    const statusCart = getContratoStatus(edificio.contratos, "CARTELERÍA");
                    if (!statusInv && !statusCart) {
                      return <span style={{ color: "#999" }}>—</span>;
                    }
                    return (
                      <>
                        {statusInv && (
                          <div style={{ color: statusInv.color, fontWeight: "bold", fontSize: "0.7rem" }}>
                            PUB: {statusInv.status}
                          </div>
                        )}
                        {statusCart && (
                          <div style={{ color: statusCart.color, fontWeight: "bold", fontSize: "0.7rem" }}>
                            CART: {statusCart.status}
                          </div>
                        )}
                      </>
                    );
                  })()}
                </td>
                <td className={styles.colAcciones} onClick={(e) => e.stopPropagation()}>
                  <KebabMenu items={accionesDeEdificio(edificio)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal para editar Empresas - 2 columnas */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Empresas - {modalEdificio?.edificio?.toUpperCase()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>
                <strong>Lista de Empresas</strong> (separadas por coma)
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                value={modalData.empresaslistado}
                onChange={(e) => setModalData({ ...modalData, empresaslistado: e.target.value })}
                style={{ textTransform: "uppercase" }}
                placeholder="EMPRESA1, EMPRESA2, EMPRESA3..."
              />
            </Form.Group>

            <div style={{ display: "flex", gap: "20px" }}>
              {/* Columna izquierda - Todas las empresas con checkboxes */}
              <div style={{ flex: 1 }}>
                <Form.Label>
                  <strong>Seleccionar Destacadas</strong>
                  <span style={{ color: "#666", fontSize: "12px", marginLeft: "8px" }}>(marcar hasta 5)</span>
                </Form.Label>
                <div
                  style={{
                    maxHeight: "350px",
                    overflowY: "auto",
                    border: "1px solid #ccc",
                    padding: "10px",
                    borderRadius: "4px",
                    backgroundColor: "#f8f9fa",
                  }}
                >
                  {empresasArray.length > 0 ? (
                    empresasArray.map((empresa, idx) => (
                      <Form.Check
                        key={idx}
                        type="checkbox"
                        id={`empresa-${idx}`}
                        label={empresa.toUpperCase()}
                        checked={destacadasArray.includes(empresa)}
                        onChange={() => handleToggleDestacada(empresa)}
                        style={{ marginBottom: "4px" }}
                      />
                    ))
                  ) : (
                    <span style={{ color: "#999" }}>Ingrese empresas arriba</span>
                  )}
                </div>
              </div>

              {/* Columna derecha - Empresas destacadas */}
              <div style={{ flex: 1 }}>
                <Form.Label>
                  <strong>Empresas Destacadas</strong>
                  <span
                    style={{ color: destacadasArray.length >= 5 ? "red" : "#666", fontSize: "12px", marginLeft: "8px" }}
                  >
                    ({destacadasArray.length}/5)
                  </span>
                </Form.Label>
                <div
                  style={{
                    minHeight: "350px",
                    border: "1px solid #28a745",
                    padding: "10px",
                    borderRadius: "4px",
                    backgroundColor: "#e8f5e9",
                  }}
                >
                  {destacadasArray.length > 0 ? (
                    destacadasArray.map((empresa, idx) => (
                      <div
                        key={idx}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "6px 8px",
                          backgroundColor: "white",
                          borderRadius: "4px",
                          marginBottom: "4px",
                          border: "1px solid #28a745",
                        }}
                      >
                        <span style={{ fontWeight: "bold" }}>{empresa.toUpperCase()}</span>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          style={{ fontSize: "10px", padding: "2px 6px" }}
                          onClick={() => handleToggleDestacada(empresa)}
                        >
                          ×
                        </button>
                      </div>
                    ))
                  ) : (
                    <span style={{ color: "#999" }}>Ninguna empresa destacada</span>
                  )}
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSaveEmpresasModal}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para editar Vetos - Categorías ordenadas alfabéticamente */}
      <Modal show={showVetosModal} onHide={() => setShowVetosModal(false)} dialogClassName="modal-90w">
        <Modal.Header closeButton>
          <Modal.Title>Vetos - {vetosModalEdificio?.edificio?.toUpperCase()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ color: "#666", marginBottom: "15px" }}>
            Seleccione las categorías que desea vetar para este edificio:
          </p>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: "4px 10px",
              maxHeight: "600px",
              overflowY: "auto",
              padding: "15px 25px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          >
            {categoriasOrdenadas.map((categoria) => {
              const isSelected = vetosModalData.includes(categoria.id.toString());
              return (
                <Form.Check
                  key={categoria.id}
                  type="checkbox"
                  id={`veto-modal-${categoria.id}`}
                  label={
                    <span
                      style={{
                        backgroundColor: isSelected ? "#ffebee" : "transparent",
                        color: isSelected ? "#c62828" : "inherit",
                        padding: "1px 4px",
                        borderRadius: "3px",
                        fontWeight: isSelected ? 500 : 400,
                      }}
                    >
                      {categoria.nombre}
                    </span>
                  }
                  checked={isSelected}
                  onChange={() => handleVetosModalChange(categoria.id.toString())}
                  style={{
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    margin: 0,
                  }}
                />
              );
            })}
          </div>
          <div style={{ marginTop: "10px", color: "#666" }}>
            <strong>Vetos seleccionados:</strong> {vetosModalData.length}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowVetosModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSaveVetosModal}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para editar Contratos */}
      <Modal show={showContratosModal} onHide={() => setShowContratosModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Contratos - {contratosModalEdificio?.edificio?.toUpperCase()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ display: "flex", gap: "30px" }}>
            {/* Sección INVENTARIO */}
            <div style={{ flex: 1 }}>
              <div
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}
              >
                <strong style={{ color: "#0d6efd" }}>INVENTARIO PUBLICITARIO</strong>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => handleAddContrato("INVENTARIO")}
                  style={{ fontSize: "11px" }}
                >
                  + Agregar
                </Button>
              </div>
              <div style={{ border: "1px solid #0d6efd", borderRadius: "4px", padding: "10px", minHeight: "200px" }}>
                {contratosModalData
                  .map((contrato, index) => ({ ...contrato, originalIndex: index }))
                  .filter((c) => c.tipo === "INVENTARIO")
                  .map((contrato) => (
                    <div
                      key={contrato.originalIndex}
                      style={{
                        backgroundColor: "#f8f9fa",
                        padding: "10px",
                        borderRadius: "4px",
                        marginBottom: "8px",
                        border: "1px solid #dee2e6",
                      }}
                    >
                      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <Form.Group style={{ flex: 1 }}>
                          <Form.Label style={{ fontSize: "11px", marginBottom: "2px" }}>Inicio</Form.Label>
                          <Form.Control
                            type="date"
                            size="sm"
                            value={contrato.fechainicio}
                            onChange={(e) =>
                              handleContratoChange(contrato.originalIndex, "fechainicio", e.target.value)
                            }
                          />
                        </Form.Group>
                        <Form.Group style={{ flex: 1 }}>
                          <Form.Label style={{ fontSize: "11px", marginBottom: "2px" }}>Fin</Form.Label>
                          <Form.Control
                            type="date"
                            size="sm"
                            value={contrato.fechafin}
                            onChange={(e) => handleContratoChange(contrato.originalIndex, "fechafin", e.target.value)}
                          />
                        </Form.Group>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => handleRemoveContrato(contrato.originalIndex)}
                          style={{ fontSize: "10px", padding: "4px 8px", marginTop: "18px" }}
                        >
                          ×
                        </Button>
                      </div>
                    </div>
                  ))}
                {contratosModalData.filter((c) => c.tipo === "INVENTARIO").length === 0 && (
                  <span style={{ color: "#999", fontSize: "12px" }}>Sin contratos de inventario</span>
                )}
              </div>
            </div>

            {/* Sección CARTELERÍA */}
            <div style={{ flex: 1 }}>
              <div
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}
              >
                <strong style={{ color: "#198754" }}>CARTELERÍA DIGITAL</strong>
                <Button
                  variant="outline-success"
                  size="sm"
                  onClick={() => handleAddContrato("CARTELERÍA")}
                  style={{ fontSize: "11px" }}
                >
                  + Agregar
                </Button>
              </div>
              <div style={{ border: "1px solid #198754", borderRadius: "4px", padding: "10px", minHeight: "200px" }}>
                {contratosModalData
                  .map((contrato, index) => ({ ...contrato, originalIndex: index }))
                  .filter((c) => c.tipo === "CARTELERÍA")
                  .map((contrato) => (
                    <div
                      key={contrato.originalIndex}
                      style={{
                        backgroundColor: "#f8f9fa",
                        padding: "10px",
                        borderRadius: "4px",
                        marginBottom: "8px",
                        border: "1px solid #dee2e6",
                      }}
                    >
                      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <Form.Group style={{ flex: 1 }}>
                          <Form.Label style={{ fontSize: "11px", marginBottom: "2px" }}>Inicio</Form.Label>
                          <Form.Control
                            type="date"
                            size="sm"
                            value={contrato.fechainicio}
                            onChange={(e) =>
                              handleContratoChange(contrato.originalIndex, "fechainicio", e.target.value)
                            }
                          />
                        </Form.Group>
                        <Form.Group style={{ flex: 1 }}>
                          <Form.Label style={{ fontSize: "11px", marginBottom: "2px" }}>Fin</Form.Label>
                          <Form.Control
                            type="date"
                            size="sm"
                            value={contrato.fechafin}
                            onChange={(e) => handleContratoChange(contrato.originalIndex, "fechafin", e.target.value)}
                          />
                        </Form.Group>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => handleRemoveContrato(contrato.originalIndex)}
                          style={{ fontSize: "10px", padding: "4px 8px", marginTop: "18px" }}
                        >
                          ×
                        </Button>
                      </div>
                    </div>
                  ))}
                {contratosModalData.filter((c) => c.tipo === "CARTELERÍA").length === 0 && (
                  <span style={{ color: "#999", fontSize: "12px" }}>Sin contratos de cartelería</span>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowContratosModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSaveContratosModal}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Inversión */}
      <Modal
        // Un solo modal a la vez: al abrir el plan de pagos (planModalActivo), el modal Inversión se
        // oculta SIN perder su estado (onHide no se dispara al condicionar show). Al cerrar/guardar el
        // plan, planModalActivo vuelve a null y este modal reaparece donde estaba.
        show={showInversionModal && !planModalActivo}
        onHide={() => {
          setShowInversionModal(false);
          setNuevaLinea(null);
          setEditandoLinea(null);
          setMostrarDetalle(false);
        }}
        dialogClassName="modal-inversion"
      >
        <Modal.Header closeButton>
          <Modal.Title>Inversión — {inversionEdificio?.edificio?.toUpperCase()}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ display: "flex", flexDirection: "column", maxHeight: "85vh", overflow: "hidden" }}>
          {inversionLoading ? (
            <div style={{ textAlign: "center", padding: 40 }}>Cargando...</div>
          ) : (
            <>
              {/* Zona FIJA: desglose por tipo con fila TOTAL (no scrollea) */}
              <div style={{ flexShrink: 0 }}>
                {inversionActivos.length > 0 && resumenInversion.porTipo.length > 0 && (
                  <div style={{ marginBottom: 16 }}>
                    <div style={{ fontSize: "0.75rem", color: "#6c757d", textTransform: "uppercase", marginBottom: 4 }}>
                      Desglose por tipo
                    </div>
                    <table className={`table table-sm ${styles.densaInversion}`}>
                      <thead className="table-light">
                        <tr>
                          <th style={{ textAlign: "left" }}>Tipo</th>
                          <th style={{ textAlign: "right" }}>Inversión</th>
                          <th style={{ textAlign: "right" }}>Valor libro</th>
                        </tr>
                      </thead>
                      <tbody>
                        {resumenInversion.porTipo.map((t) => (
                          <tr key={t.tipo_activo}>
                            <td style={{ textAlign: "left" }}>{getTipoActivoLabel(t.tipo_activo)}</td>
                            <td style={{ textAlign: "right" }}>{formatAmount(t.inversionEjecutada, monedaLocal)}</td>
                            <td style={{ textAlign: "right" }}>{formatAmount(t.valorLibroHoy, monedaLocal)}</td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr style={{ fontWeight: 700, borderTop: "2px solid #adb5bd" }}>
                          <td style={{ textAlign: "left" }}>TOTAL</td>
                          <td style={{ textAlign: "right" }}>
                            {formatAmount(resumenInversion.inversionEjecutada, monedaLocal)}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {formatAmount(resumenInversion.valorLibroHoy, monedaLocal)}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                )}
              </div>
              {/* Toggle del detalle (fijo): expande la lista de líneas + alta */}
              <div style={{ flexShrink: 0, display: "flex", gap: 12, alignItems: "center", marginBottom: 8 }}>
                <button
                  className="btn btn-link btn-sm"
                  style={{ padding: 0, textDecoration: "none" }}
                  onClick={() => setMostrarDetalle((v) => !v)}
                >
                  {mostrarDetalle ? "▾" : "▸"} Ver detalle de activos ({inversionActivos.length})
                </button>
                {mostrarDetalle && (
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() =>
                      setNuevaLinea({
                        tipo_activo: "",
                        descripcion: "",
                        moneda: "CLP",
                        costo_unitario: "",
                        fecha_planificada: "",
                        proyecto_nombre: "",
                        proveedor_id: null,
                        exento_iva: false, // por defecto afecto (lleva IVA)
                      })
                    }
                    disabled={!!nuevaLinea || !!editandoLinea}
                  >
                    + Agregar línea
                  </button>
                )}
              </div>
              {/* Zona DETALLE (desplegable): scrollea interno, toma el alto restante */}
              {mostrarDetalle && (
                <div style={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
                  <table className={`table table-sm table-bordered ${styles.densaInversion} ${styles.tablaDetalleInversion}`}>
                    {/* Anchos autoritativos por <colgroup> (10.161). 10 columnas:
                        Tipo·Proveedor·Descripción·Moneda·Neto·IVA·Total·Fecha·Estado·Acciones = 100% */}
                    <colgroup>
                      <col style={{ width: "11%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "18%" }} />
                      <col style={{ width: "6%" }} />
                      <col style={{ width: "9%" }} />
                      <col style={{ width: "9%" }} />
                      <col style={{ width: "9%" }} />
                      <col style={{ width: "9%" }} />
                      <col style={{ width: "8%" }} />
                      <col style={{ width: "6%" }} />
                    </colgroup>
                    <thead className="table-dark">
                      <tr>
                        <th style={{ textAlign: "left" }}>Tipo</th>
                        <th style={{ textAlign: "left" }}>Proveedor</th>
                        <th style={{ textAlign: "left" }}>Descripción</th>
                        <th>Moneda</th>
                        <th style={{ textAlign: "right" }}>Neto</th>
                        <th style={{ textAlign: "right" }}>IVA</th>
                        <th style={{ textAlign: "right" }}>Total</th>
                        <th>Fecha</th>
                        <th>Estado</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {inversionActivos.length === 0 && !nuevaLinea && (
                        <tr>
                          <td colSpan={10} style={{ textAlign: "center", color: "#999", padding: 30 }}>
                            Sin inversiones registradas para este edificio
                          </td>
                        </tr>
                      )}
                      {inversionActivos.map((a) =>
                        editandoLinea?.id === a.id ? (
                          <tr key={a.id} style={{ background: "#e8f4fd" }}>
                            <td>
                              <select
                                className="form-select form-select-sm"
                                value={editandoLinea.tipo_activo || ""}
                                onChange={(e) => setEditandoLinea((p) => ({ ...p, tipo_activo: e.target.value }))}
                              >
                                <option value="">Tipo...</option>
                                {TIPOS_ACTIVO_INVERSION.map((t) => (
                                  <option key={t} value={t}>
                                    {getTipoActivoLabel(t)}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <td>
                              {/* Proveedor editable — usa el proveedor_id que ya vive en editandoLinea y lo
                                  guarda handleGuardarEdicion (sin cambios de lógica). */}
                              <select
                                className="form-select form-select-sm"
                                value={editandoLinea.proveedor_id || ""}
                                onChange={(e) =>
                                  setEditandoLinea((p) => ({ ...p, proveedor_id: Number(e.target.value) || null }))
                                }
                                title="Proveedor"
                              >
                                <option value="">Proveedor…</option>
                                {inversionProveedores.map((prov) => (
                                  <option key={prov.id} value={prov.id}>
                                    {prov.nombre}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <td>
                              {/* Descripción (texto libre, opcional). */}
                              <input
                                className="form-control form-control-sm"
                                type="text"
                                placeholder="Descripción"
                                value={editandoLinea.descripcion || ""}
                                onChange={(e) => setEditandoLinea((p) => ({ ...p, descripcion: e.target.value }))}
                              />
                            </td>
                            <td>
                              <select
                                className="form-select form-select-sm"
                                value={editandoLinea.moneda || "CLP"}
                                onChange={(e) => setEditandoLinea((p) => ({ ...p, moneda: e.target.value }))}
                                style={{ paddingRight: 22 }}
                              >
                                <option value="CLP">CLP</option>
                                <option value="USD">USD</option>
                                <option value="UF">UF</option>
                              </select>
                            </td>
                            <td>
                              <input
                                className="form-control form-control-sm"
                                type="text"
                                inputMode="numeric"
                                placeholder="Monto"
                                value={formatMontoInput(editandoLinea.costo_unitario)}
                                onChange={(e) =>
                                  setEditandoLinea((p) => ({ ...p, costo_unitario: parseMontoInput(e.target.value) }))
                                }
                                style={{ textAlign: "right" }}
                              />
                            </td>
                            {(() => {
                              const { iva, total, aplica } = ivaLineaInversion(
                                editandoLinea.costo_unitario,
                                editandoLinea.moneda,
                                editandoLinea.exento_iva
                              );
                              return (
                                <>
                                  <td style={{ textAlign: "right", verticalAlign: "middle" }}>
                                    <label
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 4,
                                        fontSize: "0.7rem",
                                        cursor: "pointer",
                                        justifyContent: "flex-end",
                                      }}
                                      title="Sin IVA (exento)"
                                    >
                                      <input
                                        type="checkbox"
                                        checked={!!editandoLinea.exento_iva}
                                        onChange={(e) =>
                                          setEditandoLinea((p) => ({ ...p, exento_iva: e.target.checked }))
                                        }
                                      />
                                      Sin IVA
                                    </label>
                                    <div style={{ color: aplica ? undefined : "#999", marginTop: 2 }}>
                                      {aplica ? formatAmount(iva, editandoLinea.moneda) : "—"}
                                    </div>
                                  </td>
                                  <td style={{ textAlign: "right", fontWeight: 600, verticalAlign: "middle" }}>
                                    {formatAmount(total, editandoLinea.moneda)}
                                  </td>
                                </>
                              );
                            })()}
                            <td>
                              <input
                                className="form-control form-control-sm"
                                type="date"
                                title={
                                  editandoLinea.estado === "planificado" ? "Fecha estimada de pago" : "Fecha de compra"
                                }
                                value={editandoLinea.fecha || ""}
                                onChange={(e) => setEditandoLinea((p) => ({ ...p, fecha: e.target.value }))}
                                style={!editandoLinea.fecha ? { borderColor: "#dc3545" } : undefined}
                              />
                            </td>
                            <td>
                              {/* Estado NO editable: el modal solo planifica; se preserva el estado
                                  real de la línea (editar ejecutados no los revierte). Badge de 3 valores. */}
                              {(() => {
                                const b = getBadgeEstado(editandoLinea.estado);
                                return (
                                  <span
                                    style={{
                                      fontSize: "0.7rem",
                                      padding: "2px 6px",
                                      borderRadius: 3,
                                      background: b.bg,
                                      color: b.color,
                                    }}
                                  >
                                    {b.label}
                                  </span>
                                );
                              })()}
                            </td>
                            <td style={{ whiteSpace: "nowrap" }}>
                              <div style={{ display: "flex", gap: 4, justifyContent: "center" }}>
                                <button
                                  className="btn btn-success btn-sm"
                                  style={{ fontSize: "10px" }}
                                  title="Guardar cambios"
                                  onClick={handleGuardarEdicion}
                                >
                                  ✓
                                </button>
                                <button
                                  className="btn btn-secondary btn-sm"
                                  style={{ fontSize: "10px" }}
                                  title="Cancelar"
                                  onClick={() => setEditandoLinea(null)}
                                >
                                  ×
                                </button>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          <tr key={a.id} style={{ background: a.estado === "planificado" ? "#fff9e6" : "#f0fff0" }}>
                            <td style={{ textAlign: "left" }}>{getTipoActivoLabel(a.tipo_activo)}</td>
                            <td
                              className={styles.celdaTruncada}
                              style={{ textAlign: "left" }}
                              title={a.proveedor?.nombre || undefined}
                            >
                              {a.proveedor?.nombre || "—"}
                            </td>
                            {/* Descripción: legacy (== tipo_activo o vacía) → "—". Una línea, ellipsis + title. */}
                            <td
                              className={styles.celdaTruncada}
                              style={{ textAlign: "left" }}
                              title={descripcionReal(a) || undefined}
                            >
                              {descripcionReal(a) || "—"}
                            </td>
                            <td>{a.moneda}</td>
                            <td style={{ textAlign: "right" }}>{formatAmount(Number(a.costo_unitario), a.moneda)}</td>
                            {(() => {
                              const { iva, total, aplica } = ivaLineaInversion(
                                a.costo_unitario,
                                a.moneda,
                                a.exento_iva
                              );
                              return (
                                <>
                                  <td style={{ textAlign: "right", color: aplica ? undefined : "#999" }}>
                                    {aplica ? formatAmount(iva, a.moneda) : "—"}
                                  </td>
                                  <td style={{ textAlign: "right", fontWeight: 600 }}>
                                    {formatAmount(total, a.moneda)}
                                  </td>
                                </>
                              );
                            })()}
                            <td>{a.fecha_planificada || a.fecha_compra || "—"}</td>
                            <td>
                              {(() => {
                                const b = getBadgeEstado(a.estado);
                                return (
                                  <span
                                    style={{
                                      fontSize: "0.7rem",
                                      padding: "2px 6px",
                                      borderRadius: 3,
                                      background: b.bg,
                                      color: b.color,
                                    }}
                                  >
                                    {b.label}
                                  </span>
                                );
                              })()}
                              {inversionPlanCounts[a.id] > 0 && (
                                <div style={{ marginTop: 3, fontSize: "0.68rem", color: "#2c3e50", fontWeight: 600 }}>
                                  plan de cuotas ({inversionPlanCounts[a.id]})
                                </div>
                              )}
                            </td>
                            <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                              {/* Kebab compartido (patrón 10.136), igual que la tabla principal. El
                                  dropdown (portal, z-index 2000) queda por encima del modal. */}
                              <KebabMenu
                                items={[
                                  { label: "Editar", onClick: () => handleEditarLinea(a) },
                                  ...(a.estado === "planificado"
                                    ? [
                                        {
                                          label: "Plan de pagos",
                                          onClick: () =>
                                            setPlanModalActivo({
                                              activoId: a.id,
                                              concepto: `${inversionEdificio?.edificio || ""} · ${getTipoActivoLabel(
                                                a.tipo_activo
                                              )}`,
                                            }),
                                        },
                                      ]
                                    : []),
                                  { label: "Eliminar", danger: true, onClick: () => handleEliminarLinea(a.id) },
                                ]}
                              />
                            </td>
                          </tr>
                        )
                      )}

                      {nuevaLinea && (
                        <tr style={{ background: "#e8f4fd" }}>
                          <td>
                            <select
                              className="form-select form-select-sm"
                              value={nuevaLinea.tipo_activo || ""}
                              onChange={(e) => setNuevaLinea((p) => ({ ...p, tipo_activo: e.target.value }))}
                            >
                              <option value="">Tipo...</option>
                              {TIPOS_ACTIVO_INVERSION.map((t) => (
                                <option key={t} value={t}>
                                  {getTipoActivoLabel(t)}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td>
                            {/* Proveedor OBLIGATORIO (10.177): sin esto la inversión nace sin proveedor
                                (origen de los pagos CapEx huérfanos). Borde rojo cuando falta, mismo
                                patrón que la fecha. Selección por ID (10.7). */}
                            <select
                              className="form-select form-select-sm"
                              style={!nuevaLinea.proveedor_id ? { borderColor: "#dc3545" } : undefined}
                              value={nuevaLinea.proveedor_id || ""}
                              onChange={(e) =>
                                setNuevaLinea((p) => ({ ...p, proveedor_id: Number(e.target.value) || null }))
                              }
                              title="Proveedor (obligatorio)"
                            >
                              <option value="">Proveedor…</option>
                              {inversionProveedores.map((prov) => (
                                <option key={prov.id} value={prov.id}>
                                  {prov.nombre}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td>
                            {/* Descripción (texto libre, opcional). */}
                            <input
                              className="form-control form-control-sm"
                              type="text"
                              placeholder="Descripción"
                              value={nuevaLinea.descripcion || ""}
                              onChange={(e) => setNuevaLinea((p) => ({ ...p, descripcion: e.target.value }))}
                            />
                          </td>
                          <td>
                            <select
                              className="form-select form-select-sm"
                              value={nuevaLinea.moneda || "CLP"}
                              onChange={(e) => setNuevaLinea((p) => ({ ...p, moneda: e.target.value }))}
                              style={{ paddingRight: 22 }}
                            >
                              <option value="CLP">CLP</option>
                              <option value="USD">USD</option>
                              <option value="UF">UF</option>
                            </select>
                          </td>
                          <td>
                            <input
                              className="form-control form-control-sm"
                              type="text"
                              inputMode="numeric"
                              placeholder="Monto"
                              value={formatMontoInput(nuevaLinea.costo_unitario)}
                              onChange={(e) =>
                                setNuevaLinea((p) => ({ ...p, costo_unitario: parseMontoInput(e.target.value) }))
                              }
                              style={{ textAlign: "right" }}
                            />
                          </td>
                          {(() => {
                            const { iva, total, aplica } = ivaLineaInversion(
                              nuevaLinea.costo_unitario,
                              nuevaLinea.moneda,
                              nuevaLinea.exento_iva
                            );
                            return (
                              <>
                                <td style={{ textAlign: "right", verticalAlign: "middle" }}>
                                  <label
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 4,
                                      fontSize: "0.7rem",
                                      cursor: "pointer",
                                      justifyContent: "flex-end",
                                    }}
                                    title="Sin IVA (exento)"
                                  >
                                    <input
                                      type="checkbox"
                                      checked={!!nuevaLinea.exento_iva}
                                      onChange={(e) => setNuevaLinea((p) => ({ ...p, exento_iva: e.target.checked }))}
                                    />
                                    Sin IVA
                                  </label>
                                  <div style={{ color: aplica ? undefined : "#999", marginTop: 2 }}>
                                    {aplica ? formatAmount(iva, nuevaLinea.moneda) : "—"}
                                  </div>
                                </td>
                                <td style={{ textAlign: "right", fontWeight: 600, verticalAlign: "middle" }}>
                                  {formatAmount(total, nuevaLinea.moneda)}
                                </td>
                              </>
                            );
                          })()}
                          <td>
                            <input
                              className="form-control form-control-sm"
                              type="date"
                              title="Fecha estimada de pago (obligatoria)"
                              value={nuevaLinea.fecha_planificada || ""}
                              onChange={(e) => setNuevaLinea((p) => ({ ...p, fecha_planificada: e.target.value }))}
                              style={!nuevaLinea.fecha_planificada ? { borderColor: "#dc3545" } : undefined}
                            />
                          </td>
                          <td>
                            {/* El modal solo planifica: toda alta nace 'planificado' (no editable). */}
                            {(() => {
                              const b = getBadgeEstado("planificado");
                              return (
                                <span
                                  style={{
                                    fontSize: "0.7rem",
                                    padding: "2px 6px",
                                    borderRadius: 3,
                                    background: b.bg,
                                    color: b.color,
                                  }}
                                >
                                  {b.label}
                                </span>
                              );
                            })()}
                          </td>
                          <td style={{ whiteSpace: "nowrap" }}>
                            <div style={{ display: "flex", gap: 4, justifyContent: "center" }}>
                              <button
                                className="btn btn-success btn-sm"
                                style={{ fontSize: "10px" }}
                                onClick={handleGuardarLinea}
                              >
                                ✓
                              </button>
                              <button
                                className="btn btn-secondary btn-sm"
                                style={{ fontSize: "10px" }}
                                onClick={() => setNuevaLinea(null)}
                              >
                                ×
                              </button>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  {/* Tres cifras de la MISMA fuente ya convertida a moneda local (resumenInversionEdificio,
                      TC día-15 por activo — sin raw-sum ni buckets por moneda, regla 10.185). Partición
                      limpia: Planificado {planificado} · Ejecutado {activo,en_reparacion} · Pagado s/factura
                      {ejecutado_sin_factura}. Formato por formatAmount (10.1), nunca string de moneda hardcodeado. */}
                  {inversionActivos.length > 0 && (
                    <div style={{ textAlign: "right", fontSize: "0.85rem", marginTop: 8 }}>
                      <strong>Planificado: </strong>
                      {formatAmount(resumenInversion.inversionPlanificada, monedaLocal)}
                      {" | "}
                      <strong>Ejecutado: </strong>
                      {formatAmount(resumenInversion.inversionEjecutada, monedaLocal)}
                      {" | "}
                      <strong>Pagado s/factura: </strong>
                      {formatAmount(resumenInversion.inversionPagadaSinFactura, monedaLocal)}
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>

      {/* Plan de pagos (CapEx en cuotas) — reutiliza el modal de Caja; escribe plan_pagos_activos
          (misma tabla → única fuente). Se abre sobre el modal Inversión. */}
      {planModalActivo && (
        <PlanPagosActivoModal
          show={!!planModalActivo}
          onHide={() => setPlanModalActivo(null)}
          activoId={planModalActivo.activoId}
          concepto={planModalActivo.concepto}
          userId={usuarioId}
          onSaved={() => {
            setPlanModalActivo(null);
            cargarPlanCounts(inversionActivos);
          }}
        />
      )}

      {/* Chart Modal - Crecimiento Red */}
      <EdificiosChartModal open={showChartModal} onClose={() => setShowChartModal(false)} edificios={edificios} />

      {/* Modal de ficha técnica — puerta única (Bloque C), gateado a [1,4].
          modo dinámico: edificioModalData con datos → editar; null → crear (ficha vacía). */}
      <Modal show={showEdificioModal} onHide={() => setShowEdificioModal(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            {edificioModalData ? `Editar edificio — ${edificioModalData?.edificio?.toUpperCase()}` : "Nuevo edificio"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showEdificioModal && (
            <EdificioForm
              key={edificioModalData?.id ?? "nuevo"}
              modo={edificioModalData ? "editar" : "crear"}
              edificio={edificioModalData}
              pais={pais}
              proveedores={edificioModalProveedores}
              onSubmit={handleSaveEdificioModal}
              onCancel={() => setShowEdificioModal(false)}
            />
          )}
          {edificioModalSaving && <div className="text-muted mt-2">Guardando…</div>}
        </Modal.Body>
      </Modal>

      {/* Modal de comisión de edificio (Bloque C Fase 4), gateado a [1,4].
          key por id → remonta limpio y precarga los tramos del edificio elegido. */}
      {showComisionModal && comisionModalEdificio && (
        <EdificioComisionModal
          key={comisionModalEdificio.id}
          show={showComisionModal}
          edificio={comisionModalEdificio}
          saving={comisionModalSaving}
          onClose={() => setShowComisionModal(false)}
          onSubmit={handleSaveComisionModal}
        />
      )}
    </div>
  );
};

export default EdificiosTable;
